// extracted by mini-css-extract-plugin
module.exports = {"container":"MultiFileUploadPlaceholder-module__container","placeholder":"MultiFileUploadPlaceholder-module__placeholder"};